import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
var wt = /*#__PURE__*/function () {
  function wt(t, s, i, h, l) {
    _classCallCheck(this, wt);
    this.triggerId = t, this.qr = s, this.Tr = i, this.Er = h, this.Gr = l, this.triggerId = t, this.qr = s, this.Tr = i, this.Er = h, this.Gr = l;
  }
  _createClass(wt, null, [{
    key: "fromJson",
    value: function fromJson(t, s, i, h, l) {
      return null == t || null == t.trigger_id ? null : new wt(t.trigger_id, s, i, h, l);
    }
  }]);
  return wt;
}();
export { wt as default };